/*
 * Fact find v2 - client-side API wrapper.
 *
 * Uses the shared axios instance from src/api/server.js which already
 * attaches the Firebase ID token in the Authorization header.
 */
import server from '../../api/server';

const post = async (url, body) => {
  const res = await server.post(url, body || {});
  // The shared axios interceptor sometimes returns the error object as the
  // resolved value (see src/api/server.js response interceptor). Normalise.
  if (!res || res.status >= 400 || !res.data) {
    throw new Error(`Request to ${url} failed`);
  }
  return res.data;
};

export const fetchFactFindV2 = (application_id) =>
  post('/v2/factfindform/fetch', { application_id });

export const saveFactFindV2Section = (application_id, section, data) =>
  post('/v2/factfindform/save', { application_id, section, data });

export const submitFactFindV2 = (application_id) =>
  post('/v2/factfindform/submit', { application_id });

export const seedFactFindV2Applicants = (application_id) =>
  post('/v2/factfindform/seedApplicants', { application_id });

export const listFactFindV2Versions = (application_id) =>
  post('/v2/factfindform/versions', { application_id });

export const fetchFactFindV2Version = (application_id, version_id) =>
  post('/v2/factfindform/version', { application_id, version_id });
